module.exports = __webpack_public_path__ + "static/media/data-sharing.438e8af7.svg";